export enum TooltipPosition {
  ABOVE = 'above',
  BELOW = 'below',
  BELOW_RIGHT = 'below-right',
  LEFT = 'left',
  DYNAMIC = 'dynamic',
  RIGHT = 'right',
}
